import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppConfirmToggle({ availability, checked, onChange }) {
  const available = Boolean(availability?.available);
  return (
    <label data-testid="booking-whatsapp-toggle"
           className={`flex items-center gap-3 rounded-xl border px-3 h-12 mb-2 select-none transition-colors ${
             available ? "bg-white border-sand-300 cursor-pointer" : "bg-sand-50 border-sand-200 cursor-not-allowed"}`}>
      <input type="checkbox" checked={available && checked} disabled={!available}
             onChange={(e) => onChange(e.target.checked)} data-testid="booking-whatsapp-checkbox"
             className="w-5 h-5 accent-ink-900 disabled:opacity-40" />
      <MessageCircle className={`w-4 h-4 shrink-0 ${available ? "text-emerald-700" : "text-ink-400"}`} />
      <span className={`text-sm leading-tight ${available ? "text-ink-900" : "text-ink-500"}`}>
        Invia conferma WhatsApp al cliente
        {!available && (
          <span className="block text-[11px] text-ink-500" data-testid="booking-whatsapp-unavailable">
            {availability?.reason || "Disponibile dopo attivazione WhatsApp"}
          </span>
        )}
      </span>
    </label>
  );
}
